import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import QueryString from 'qs'
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { ReqMethods, ghl } from 'enums'
import env from 'config'
import { useAppServices } from 'hook/services'
import { useBrandInfo } from 'context/brand'
import { useAgencyInfo } from 'context/agency'
// import { AgencyContext } from '../../../context/Agency.context'

function GHL() {
  const navigate = useNavigate()
  const { search } = useLocation()
  const code = new URLSearchParams(search).get('code')
  const type = new URLSearchParams(search).get('type')
  const state = new URLSearchParams(search).get('state')
  const AppServices = useAppServices()
  const [Error, setError] = useState('')
  const [agency, update] = useAgencyInfo()

  const associate = async ({ location }, creds) => {
    let payload = {}

    if (state === 'workflow') {
      payload = {
        ghl: {
          location_id: creds.locationId,
          company_id: location.companyId,
          access_token: creds.access_token,
          refresh_token: creds.refresh_token,
        },
      }
    }

    if (state === 'adminghl') {
      payload = {
        admin_ghl: {
          location_id: creds.locationId,
          company_id: location.companyId,
          access_token: creds.access_token,
          refresh_token: creds.refresh_token,
        },
      }
    }
    const { response } = await AppServices.super_admin_settings.update({ payload })
    if (!response) return setError('Something went wrong while integration, please try latter')
    update(payload)
    return navigate(-2)
  }

  const getLocation = async (creds) => {
    const payload = {
      method: ReqMethods.GET,
      path: `${ghl.APIs.v2.location(creds.locationId)}`,
      key: creds.access_token,
      refresh_token: creds.refresh_token,
    }
    const { response } = await AppServices.services.ghl.call_service({ payload })

    if (!response) return setError('Something went wrong while integration, please try latter')

    return response && associate(response.data, creds)
  }

  const getCreds = async () => {
    const payload = {
      method: ReqMethods.POST,
      path: ghl.APIs.oauth,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      payload: QueryString.stringify({
        client_id: '694968832d8dea5c1f21e540-mjie1tq8',
        client_secret: '145afff7-d8b1-4f22-b540-94bc2f2de462',
        grant_type: 'authorization_code',
        code,
        refresh_token: '',
      }),
    }
    const { response } = await AppServices.services.ghl.call_service({ payload })

    if (!response) return setError('Something went wrong while integration, please try latter')
    // if(location_id !== response.data.locationId) return setError('location ID mismatch')
    return response && getLocation(response.data)
  }

  const onLoad = () => {
    getCreds()
  }

  useEffect(onLoad, [])

  return (
    <MDBox>
      {!Error && <MDBox>Integrating please wait...</MDBox>}
      {Error && (
        <MDBox>
          {Error}
          <MDButton onClick={() => navigate(-2)}>Go Back</MDButton>
        </MDBox>
      )}
    </MDBox>
  )
}

export default GHL
